<template>
  <div class="device">
    <div v-if="false">{{ userSelectAddressData }}</div>
    <div class="layout">
      <div class="device-setting">
        <div class="m16 pagination-bg-white device">
          <!-- 上半部分 -->
          <div
            class="flex"
            ref="topLine"
            style="border-bottom: 0.0625rem solid #ebebeb"
          >
            <div class="flex" style="width: 22.67%">
              <div style="width: 100%" class="bg-f p16 mr16 border-r-4">
                <p class="fs14 bold">
                  <i class="iconfont c-green mr10">&#xe616;</i>城市核定投放统计
                </p>
                <div v-show="checkUserAuth(64, 60)">
                  <div id="c3"></div>
                </div>
              </div>
            </div>
            <div class="flex" style="width: 34.33%">
              <div style="width: 100%" class="bg-f p16 mr16 border-r-4">
                <p class="fs14 bold">
                  <i class="iconfont c-blue mr10">&#xe616;</i>在线量占比统计
                </p>
                <div v-show="checkUserAuth(64, 60)">
                  <div id="c1"></div>
                </div>
              </div>
            </div>
            <div class="flex1 bg-f p16 border-r-4">
              <div style="width: 100%">
                <div class="flex justbetween mb10">
                  <p class="fs14 bold" style="width: 7.8125rem">
                    <i class="iconfont c-blue mr10">&#xe616;</i>站点排名分析
                  </p>
                  <div>
                    <el-button
                      v-show="checkUserAuth(64, 63) && isAggregation"
                      @click="onExportSite"
                      class="mr2"
                      size="mini"
                      type="primary"
                      style="background-color: #3e7878;border-color: #3e7878;">导出</el-button>
                    <el-radio-group
                      @change="onSiteType"
                      class="mr2"
                      size="mini"
                      v-model="siteType"
                      fill="#3e7878">
                      <el-radio-button label="时"></el-radio-button>
                      <el-radio-button label="日"></el-radio-button>
                      <el-radio-button label="月"></el-radio-button>
                    </el-radio-group>
                    <el-date-picker
                      :clearable="false"
                      class="datestyle"
                      size="mini"
                      v-model="siteRankAllTime"
                      @change="onSiteRankAllTime"
                      :type="
                        siteType === '时'
                          ? 'datetime'
                          : siteType === '日'
                          ? 'date'
                          : 'month'
                      "
                      popper-class="datestyle2"
                      placeholder="选择日期时间"
                      :format="
                        siteType === '时'
                          ? 'yyyy-MM-dd HH'
                          : siteType === '日'
                          ? 'yyyy-MM-dd'
                          : 'yyyy-MM'
                      "
                      default-time="12">
                    </el-date-picker>
                  </div>
                </div>
                <div class="table-height-limit" v-show="checkUserAuth(64, 59)">
                  <el-table
                    v-loading.body="tableLoading"
                    :data="tableData"
                    height="210px"
                    style="width: 99%"
                    @sort-change="handleSortChange"
                    class="site_ranking_table"
                    highlight-current-row>
                    <el-table-column prop="index" label="排名" align="center">
                      <template v-slot="props">
                        <span> {{ props.$index + 1 }} </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="siteName" width="200" label="站点名称" align="center">
                      <template v-slot="props">
                        <span @click="jjSearch(props.row)" class="blue pointer">
                          {{ props.row["siteName"] }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rentNum" sortable label="租车" align="center"/>
                    <el-table-column prop="returnNum" sortable label="还车" align="center"/>
                    <el-table-column prop="upNum" sortable label="上架" align="center"/>
                    <el-table-column prop="downNum" sortable label="下架" align="center"/>
                  </el-table>
                  <div v-show="!checkUserAuth(3, 16)">
                    您的账户没有权限查看此内容！
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 下半部分 -->
          <div class="mt16 flex" :style="{ height: (realHeight) / 16 + 'rem' }">
            <div class="flex1 p16 border-r-4 bg-f mr16">
              <div style="width: 100%">
                <div class="flex justbetween mb20">
                  <p class="fs14 bold">
                    <i class="iconfont c-blue mr10">&#xe616;</i>潮汐统计
                  </p>
                  <div>
                    <el-select
                      v-if="dataType === '年'"
                      @change="onSelectYear"
                      size="mini"
                      v-model="selectYear"
                      style="width: 100px;float: left;margin-right: 10px;"
                      placeholder="请选择">
                      <el-option
                        v-for="item in selectYears"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-radio-group
                      @change="onAction"
                      class="mr12"
                      size="mini"
                      v-model="action"
                      fill="#3e7878">
                      <el-radio-button label="租车"></el-radio-button>
                      <el-radio-button label="还车"></el-radio-button>
                      <el-radio-button label="租还"></el-radio-button>
                      <el-radio-button label="上架"></el-radio-button>
                      <el-radio-button label="下架"></el-radio-button>
                      <el-radio-button label="上下架"></el-radio-button>
                    </el-radio-group>
                    <el-radio-group
                      @change="onDataType"
                      size="mini"
                      v-model="dataType"
                      fill="#3e7878">
                      <el-radio-button label="日"></el-radio-button>
                      <el-radio-button label="月"></el-radio-button>
                      <el-radio-button label="年"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 租还动态数据展示区 -->
                <div
                  class="dynamic-show"
                  v-if="
                    dynamicRentData &&
                    dynamicRentData.length &&
                    dynamicRentShowData &&
                    dynamicRentShowData.length">
                  <div
                    class="dynamic-item"
                    v-for="(item, index) in dynamicRentShowData"
                    :key="'rent' + item.name + item.value + index">
                    <p class="num" :class="{ blue: !index }">
                      <animate-number
                        :from="item.from"
                        :to="item.to"
                        :duration="item.duration"
                        easing="easeOutQuad"
                        :formatter="animateNumberFormatter">
                      </animate-number>
                    </p>
                    <p class="name">{{ item.name }}</p>
                  </div>
                </div>
                <div
                  class="dynamic-show"
                  v-if="
                    dynamicReturnData &&
                    dynamicReturnData.length &&
                    dynamicReturnShowData &&
                    dynamicReturnShowData.length">
                  <div
                    class="dynamic-item"
                    v-for="(item, index) in dynamicReturnShowData"
                    :key="'return' + item.name + item.value + index">
                    <p class="num" :class="{ blue: !index }">
                      <animate-number
                        :from="item.from"
                        :to="item.to"
                        :duration="item.duration"
                        easing="easeOutQuad"
                        :formatter="animateNumberFormatter"></animate-number>
                    </p>
                    <p class="name">{{ item.name }}</p>
                  </div>
                </div>
                <!-- 上下架动态数据展示区 -->
                <div
                  class="dynamic-show"
                  v-if="
                    dynamicUpData &&
                    dynamicUpData.length &&
                    dynamicUpShowData &&
                    dynamicUpShowData.length">
                  <div
                    class="dynamic-item"
                    v-for="(item, index) in dynamicUpShowData"
                    :key="'up' + item.name + item.value + index">
                    <p class="num" :class="{ blue: !index }">
                      <animate-number
                        :from="item.from"
                        :to="item.to"
                        :duration="item.duration"
                        easing="easeOutQuad"
                        :formatter="animateNumberFormatter">
                      </animate-number>
                    </p>
                    <p class="name">{{ item.name }}</p>
                  </div>
                </div>
                <div
                  class="dynamic-show"
                  v-if="
                    dynamicDownData &&
                    dynamicDownData.length &&
                    dynamicDownShowData &&
                    dynamicDownShowData.length">
                  <div
                    class="dynamic-item"
                    v-for="(item, index) in dynamicDownShowData"
                    :key="'down' + item.name + item.value + index">
                    <p class="num" :class="{ blue: !index }">
                      <animate-number
                        :from="item.from"
                        :to="item.to"
                        :duration="item.duration"
                        easing="easeOutQuad"
                        :formatter="animateNumberFormatter"></animate-number>
                    </p>
                    <p class="name">{{ item.name }}</p>
                  </div>
                </div>
                <template>
                  <div id="c2" v-show="checkUserAuth(64, 134)"></div>
                </template>
              </div>
            </div>
            <div style="width: 43%">
              <div
                style="height: 100%; box-sizing: border-box"
                class="p16 border-r-4 bg-f">
                <total-sum-chart
                  @explorer="onExportLogShowModel(4, $event)"
                  v-show="checkUserAuth(64, 134)"
                  :isAggregation="isAggregation"
                  :selfAreaId="selfAreaId"
                  :realHeight="realHeight">
                  <div class="mb20 title" slot="title">
                    <p class="fs14 bold">
                      <i class="iconfont c-blue mr10">&#xe616;</i>品牌车辆状态统计
                    </p>
                  </div>
                </total-sum-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 一级弹窗 -->
    <w-dialog
      ref="w-dialog-month"
      :title="dialogTitleMonth"
      width="90%"
      :isShowFooter="false"
      @handleCloseRight="handleCloseMonth">
      <template v-slot:content>
        <div id="cMonth"></div>
      </template>
    </w-dialog>
    <w-dialog
      ref="w-dialog-day"
      :title="dialogTitleDay"
      width="85%"
      :isShowFooter="false"
      @handleCloseRight="handleCloseDay">
      <template v-slot:content>
        <div id="cDay"></div>
      </template>
    </w-dialog>
    <w-dialog
      width="60%"
      ref="export-log"
      title="导出设置"
      sureBtnText="导出"
      @handleCloseRight="handleCloseExportLog"
      @handleClose="handleCloseExportLog"
      @onSure="onExportLogPre">
      <template v-slot:content>
        <el-form ref="form" :model="form" label-width="6.25rem">
          <el-form-item label="品牌选择：">
            <el-checkbox-group size="mini" v-model="pinpai">
              <el-checkbox
                :label="item"
                :key="item"
                v-for="item in pinpaiNames"/>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="导出时间：" v-if="exportLogType === 2">
            <el-date-picker
              size="mini"
              v-model="exportTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合法性" v-if="exportLogType === 3">
            <el-radio-group v-model="legality">
              <el-radio :label="null">全部</el-radio>
              <el-radio :label="0">合法</el-radio>
              <el-radio :label="1">非法</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="exportLogType === 1">
            <el-form-item label="导出时间：">
              <template v-if="dataType === '日'">
                <el-date-picker
                  size="mini"
                  v-model="exportTime"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd">
                </el-date-picker>
              </template>
              <template v-if="dataType === '月'">
                <el-date-picker
                  size="mini"
                  v-model="exportTime"
                  type="month"
                  placeholder="选择月"
                  format="yyyy-MM">
                </el-date-picker>
              </template>
              <template v-if="dataType === '年'">
                <el-date-picker
                  size="mini"
                  v-model="exportTime"
                  type="year"
                  placeholder="选择年"
                  format="yyyy">
                </el-date-picker>
              </template>
            </el-form-item>
            <el-form-item label="车辆状态：">
              <el-radio-group size="mini" v-model="exportLogAction">
                <el-radio-button label="全部"></el-radio-button>
                <el-radio-button label="下架"></el-radio-button>
                <el-radio-button label="上架"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="exportLogType === 4">
            <el-form-item label="导出时间：">
              <template v-if="logType === '日'">
                <el-time-picker
                  style="width: 200px"
                  is-range
                  size="mini"
                  v-model="exportTime"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  type="date"
                  format="HH:mm:ss">
                </el-time-picker>
              </template>
              <template v-if="logType === '月'">
                <el-date-picker
                  style="width: 200px"
                  size="mini"
                  v-model="exportTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd">
                </el-date-picker>
              </template>
              <template v-if="logType === '年'">
                <el-date-picker
                  style="width: 200px"
                  size="mini"
                  type="monthrange"
                  v-model="exportTime"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  format="yyyy-MM">
                </el-date-picker>
              </template>
            </el-form-item>
            <el-form-item label="导出数据：">
              <el-radio-group v-model="logData" size="mini">
                <el-radio-button label="1">投放</el-radio-button>
                <el-radio-button label="2">入栏</el-radio-button>
                <el-radio-button label="3">活跃</el-radio-button>
                <el-radio-button label="4">调度</el-radio-button>
                <el-radio-button label="5">周转</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-form>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import WTable from '@/components/Table/index.vue'
import WDialog from '@/components/Model/index.vue'
import { Chart, registerShape } from '@antv/g2'
import { Line } from '@antv/g2plot'
import Api from '@/api'
import { mapGetters } from 'vuex'
import staticData from './staticData.js'
import store from '@/store'
import AnimateNumber from './components/AnimateNumber'
import totalSumChart from './components/totalSumChart'

import { Loading } from 'element-ui'

export default {
  name: 'operation',
  data() {
    return {
      loading: false,
      originColors: [],
      pinpaiSort: [],
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {},
      // 美团电单
      // 青桔电单
      pSort: {},
      tableLoading: false,
      siteRankAllTime: new Date(),
      tableData: null,
      total: 0,
      tidalData: null,
      tidalDataDays: null,
      tidalDataMonths: null,
      brandIds: [],
      action: '租车', // 0-租车，1-还车
      dataType: '日', // 0-日，1-月，2-年
      chart: null, // 潮汐
      chartDays: null,
      chartMonths: null,
      selectYear: undefined,
      selectYears: [],
      dialogTitleDay: '',
      dialogTitleMonth: '',
      monthCache: null,
      pinpai: [],
      legality: null,
      pinpaiNames: [],
      realNames: [], // 每个品牌
      rentReturnBrandNames: [], // 租还品牌名称
      exportTime: new Date(),
      form: {},
      Circle1: null,
      Circle3: null,
      brandPercentData: [],
      realPinpaiNames: [],
      realHeight: 0,
      siteType: '日',
      timer: null,
      fullPileNumPage: 0,
      exportLogType: null,
      exportLogAction: '全部',
      logType: '日',
      logData: '5',
      selfAreaIdOrAggregationId: '',
      preDynamicData: undefined,
      dynamicAllToatal: {
        rent: 0,
        return: 0,
        up: 0,
        down: 0
      },
      dynamicTotalData: [],
      dynamicPinPaiNames: [],
      dynamicTotalByTime: undefined,
      // 动态数据展示
      dynamicOldestRentData: [],
      dynamicOldRentData: [],
      dynamicRentData: [],
      dynamicRentShowData: [],
      dynamicOldestReturnData: [],
      dynamicOldReturnData: [],
      dynamicReturnData: [],
      dynamicReturnShowData: [],
      getDynamicDataShowIndex: 1,
      getDynamicDispatchDataShowIndex: 1,
      dynamicUpData: [],
      dynamicDownData: [],
      dynamicUpShowData: [],
      dynamicDownShowData: [],
      dynamicTimer: null,
      dynamicApiParams: undefined,
      orderBy: 'rent_num desc'
    }
  },
  computed: {
    // vue-animate-number
    ...mapGetters([
      'userSelectAddressData',
      'user',
      'selfAreaId',
      'permissions',
      'userLevel',
      'currpath',
      'fullPileNum',
      'fullPileName',
      'userBikeType'
    ]),
    isAggregation() {
      // 是否是非复合区下的实体区
      if (this.aggregation !== undefined && this.userLevel > 1) {
        if (this.aggregation === 0 && this.aggregationId) {
          return false // 复合区下的区含有标识mold=1
        } else if (this.aggregation === 1 && this.aggregationId) {
          return true // 复合区不含有标识mold=1
        } else {
          return true
        }
      } else {
        return true
      }
    },
    staticData() {
      return staticData
    },
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    },
    isBicycle() {
      // 判断用户账号属性为自行车或者包含电动车及自行车
      return (this.userBikeType === 0 || this.userBikeType === 2)
    },
    isElectricBike() {
      // 判断用户账号属性为电动车或者包含电动车及自行车
      return (this.userBikeType === 1 || this.userBikeType === 2)
    }
  },
  watch: {
    fullPileNum(val) {
      this.fullPileNumPage = val
    }
  },
  created() {
    this.yearChange()
    this.selfAreaIdOrAggregationId = this.selfAreaId
    document.addEventListener(
      'click',
      (e) => {
        clearTimeout(this.timer)
        this.timer = null
      },
      false
    )
    this.getAreaBrandDetails()
  },
  mounted() {
    const vm = this
    vm.fullPileNumPage = vm.fullPileNum
    vm.setPollingMap()
    vm.preDestroy && vm.preDestroy()
  },
  beforeDestroy() {
    const vm = this
    clearTimeout(vm.timer)
    vm.timer = null
    clearTimeout(vm.dynamicTimer)
    vm.dynamicTimer = null

    document.removeEventListener('click', vm.handler, false)
  },
  methods: {
    yearChange () {
      var newDate = new Date()
      var startYear = newDate.getFullYear() - 4// 起始年份
      var endYear = newDate.getFullYear() // 结束年份
      this.selectYears = []
      for (var i = startYear; i <= endYear; i++) {
        this.selectYears.push({
          value: (i + ''),
          label: (i + '年')
        })
      }
      this.selectYears.sort((a, b) =>
        a.value < b.value ? 1 : a.value > b.value ? -1 : 0
      )
    },
    // 统计图汇总区域品牌信息
    getAreaBrandDetails() {
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.areaBrandDetails(params).then((res) => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.originColors.push(item.bikeColor)
            this.pinpaiSort.push(item.brandName)
          })
          const brandOriginColor = res.data.map(item => {
            return {
              brandName: item.brandName.slice(0, 2) + '单车',
              bikeColor: item.bikeColor
            }
          })
          // 单车
          const colorObject = brandOriginColor => {
            for (let i = 0; i < brandOriginColor.length; i++) {
              const { brandName, bikeColor } = brandOriginColor[i]
              this.brandOriginColor[brandName] = bikeColor
            }
            return this.brandOriginColor
          }
          this.brandOriginColor = colorObject(brandOriginColor)
          // 电动车
          const eBrandOriginColor = res.data.map(item => {
            if (item.brandName.indexOf('美团出行') > -1) {
              return {
                brandName: '美团电单',
                eBikeColor: item.ebikeColor
              }
            }
            return {
              brandName: item.brandName,
              eBikeColor: item.ebikeColor
            }
          })
          const eColorObject = eBrandOriginColor => {
            for (let i = 0; i < eBrandOriginColor.length; i++) {
              const { brandName, eBikeColor } = eBrandOriginColor[i]
              this.eOriginColor[brandName] = eBikeColor
            }
            return this.eOriginColor
          }
          this.eOriginColor = eColorObject(eBrandOriginColor)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    animateNumberFormatter: function (num) {
      return num.toFixed(0)
    },
    handler() {
      const vm = this
      clearTimeout(vm.timer)
      vm.timer = null
      clearTimeout(vm.dynamicTimer)
      vm.dynamicTimer = null
    },
    onLogType() {},
    async setPollingMap() {
      const vm = this
      const hasLength = await vm.getEnterpriseListAndHasLength()
      if (!hasLength && vm.aggregation === 0) {
        vm.selfAreaIdOrAggregationId = vm.aggregationId
      } else {
        vm.selfAreaIdOrAggregationId = vm.selfAreaId
      }
      vm.initPolling()
      vm.timer = setTimeout(vm.setPollingMap, 1000 * 60 * 30) // 30分钟
      // store.dispatch('user/setSideBarLoading', {
      //   key: 'sideBarLoading',
      //   value: true
      // }).then(() => {
      //   vm.timer = setTimeout(vm.setPollingMap, 1000 * 20) // 1分钟
      // })
    },
    async initPolling() {
      const vm = this
      if (Number(this.userLevel) === 2) {
        // 排名
        vm.siteRankAll(true)
        // 品牌占比
        await vm.initCircle1DataNew()
        // await vm.initCircle1DataNew();
        // 潮汐
        vm.tidal(null, null, null, null, null)
        // 城市核定投放统计
        // vm.initCircle3Data();
      }
      vm.$nextTick(() => {
        vm.calculateHeight()
        store
          .dispatch('user/setSideBarLoading', {
            key: 'sideBarLoading',
            value: false
          })
          .then(() => {})
      })
    },
    jjSearch(item) {
      const vm = this
      if (item.siteId) {
        const loadingInstance = Loading.service({
          fullscreen: true,
          text: '站点搜索中...'
        })
        if (vm.currpath.indexOf('index') === -1) {
          loadingInstance.close()
          store.commit('user/setUserInfo', {
            key: 'siteId',
            value: item.siteId
          })
          vm.$router.push(
            '/index' +
            (vm.currpath.split('/')[2]
              ? '/' + vm.currpath.split('/')[2]
              : '')
          )
        }
      } else {
        vm.$message.warning('该条数据存在问题，没有车辆编号！')
      }
    },
    onSiteType() {
      this.onSiteRankAllTime()
    },
    calculateHeight() {
      if (
        this.$refs.topLine &&
        window.innerHeight > this.$refs.topLine.clientHeight
      ) {
        this.realHeight =
          window.innerHeight - this.$refs.topLine.clientHeight - 100
      } else {
        this.realHeight = 500
      }
    },
    handleCloseMonth() {
      this.monthCache = null
      this.$refs['w-dialog-month'].onCloseDialog()
    },
    handleCloseDay() {
      this.$refs['w-dialog-day'].onCloseDialog()
    },
    onClickPoint(data) {
      const vm = this
      if (vm.dataType === '时') {
      } else if (data.label === '日') {
        vm.dialogTitleDay =
          new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          data.key +
          ' 曲线图'
        vm.$refs['w-dialog-day'].onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(null, data, 'cDay', 'tidalDataDays', 'chartDays')
        })
      } else if (data.label === '月') {
        vm.monthCache = Number(data.key) < 10 ? '0' + data.key : data.key
        if (vm.selectYear) {
          vm.dialogTitleMonth = vm.selectYear + '-' + data.month + ' 曲线图'
        } else {
          vm.dialogTitleMonth =
            new Date().getFullYear() + '-' + data.month + ' 曲线图'
        }
        vm.$refs['w-dialog-month'].onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(null, data, 'cMonth', 'tidalDataMonths', 'chartMonths')
        })
      }
    },
    onSelectYear() {
      this.onResetTide()
      this.tidal(true, null, null, null, null)
    },
    onResetTide() {
      this.dynamicRentData = []
      this.dynamicOldRentData = []
      this.dynamicOldestRentData = []
      this.dynamicReturnData = []
      this.dynamicOldReturnData = []
      this.dynamicOldestReturnData = []
      this.dynamicUpData = []
      this.dynamicDownData = []
      this.dynamicUpShowData = []
      this.dynamicDownShowData = []
    },
    onAction() {
      const vm = this
      vm.tidal(true, null, null, null, null)
    },
    onDataType() {
      this.dynamicRentData = []
      this.dynamicOldRentData = []
      this.dynamicOldestRentData = []
      this.dynamicReturnData = []
      this.dynamicOldReturnData = []
      this.dynamicOldestReturnData = []
      this.selectYear = undefined
      if (this.dataType === '年') {
        this.selectYear = this.selectYear ?? this.selectYears[0].value
      }
      this.tidal(null, null, null, null, null)
    },
    getDuration() {
      // 3-10秒
      return 5 * 1000
      // return Math.floor(Math.random() * 7 + 3) * 1000
    },
    getTo(old, oldest) {
      const arr = []
      for (const index in old) {
        const oldItem = old[index]
        const oldestItem = oldest[index]
        const temp = {
          ...oldItem,
          from: oldestItem.to
        }
        arr.push(temp)
      }
      return arr
    },
    getLabelName(key, type, vehicleType) {
      // type: 1-租车，2-还车
      // vehicleType: 1-单车，2-电车
      if (key === '美团电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '美团单车(租车)'
          } else if (type === 2) {
            return '美团单车(还车)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '美团电单(租车)'
          } else if (type === 2) {
            return '美团电单(还车)'
          }
        }
      }
      if (key === '哈啰电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '哈啰单车(租车)'
          } else if (type === 2) {
            return '哈啰单车(还车)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '哈啰电单(租车)'
          } else if (type === 2) {
            return '哈啰电单(还车)'
          }
        }
      }
      if (type === 1) {
        return `${key}(租车)`
      } else if (type === 2) {
        return `${key}(还车)`
      }
    },
    translateData(data) {
      let i = 1
      for (const key of this.pinpaiSort) {
        this.pSort[i + key] = data[key]
        i++
      }
    },
    translateData2(data) {
      let i = 1
      const pSort = {}
      for (const key of this.pinpaiSort) {
        pSort[i + key] = data[key]
        i++
      }
      return pSort
    },
    getDynamicDataShow() {
      // 依赖 dynamicPinPaiNames 字段取名字
      this.dynamicRentData = []
      this.dynamicReturnData = []
      this.getDynamicDataShowIndex += 10
      // 处理动态数据
      for (const dynamic of this.dynamicTotalData) {
        const key = dynamic.key
        const targetPinpai = this.brandPercentData[key]
        const hasBike = targetPinpai && (targetPinpai.PutBikeNumOrigin + targetPinpai.BrandBikeNum > 0)
        const hasEBike = targetPinpai && (targetPinpai.PutEBikeNumOrigin + targetPinpai.BrandEBikeNum > 0)
        // 租车逻辑
        if (this.action === '租车' || this.action === '租还') {
          if (this.isBicycle) {
            if (hasBike) {
              this.dynamicRentData.push(
                this.createDataItem(key, 1, 1, dynamic.bikeRentNumTotal)
              )
            }
          }
          if (this.isElectricBike) {
            if (hasEBike) {
              this.dynamicRentData.push(
                this.createDataItem(key, 1, 2, dynamic.eBikeRentNumTotal)
              )
            }
          }
        }
        // 还车逻辑
        if (this.action === '还车' || this.action === '租还') {
          if (this.isBicycle) {
            if (hasBike) {
              this.dynamicReturnData.push(
                this.createDataItem(key, 2, 1, dynamic.bikeReturnNumTotal)
              )
            }
          }
          if (this.isElectricBike) {
            if (hasEBike) {
              this.dynamicReturnData.push(
                this.createDataItem(key, 2, 2, dynamic.eBikeReturnNumTotal)
              )
            }
          }
        }
        // 租还的特殊处理
        if (this.action === '租还') {
          const odds = []
          const evens = []
          this.dynamicPinPaiNames.forEach((item, index) => {
            index % 2 === 0 ? evens.push(item) : odds.push(item)
          })
        }
      }
      // 处理总量数据
      this.handleTotalData()
      // 初始化展示数据
      this.initShowData(
        this.dynamicRentData,
        this.dynamicOldestRentData,
        this.dynamicOldRentData,
        'dynamicRentShowData'
      )
      this.initShowData(
        this.dynamicReturnData,
        this.dynamicOldestReturnData,
        this.dynamicOldReturnData,
        'dynamicReturnShowData'
      )
    },
    // 新增的公共方法
    createDataItem(key, type, vehicleType, value) {
      return {
        name: this.getLabelName(key, type, vehicleType),
        from: 0,
        to: value,
        duration: this.getDuration()
      }
    },
    handleTotalData() {
      if (this.action === '租车' || this.action === '租还') {
        this.dynamicRentData.unshift({
          name: '租车总量',
          from: 0,
          to: this.dynamicAllToatal.rent,
          duration: 6000
        })
      }
      if (this.action === '还车' || this.action === '租还') {
        this.dynamicReturnData.unshift({
          name: '还车总量',
          from: 0,
          to: this.dynamicAllToatal.return,
          duration: 6000
        })
      }
    },
    initShowData(sourceData, oldestData, oldData, showDataKey) {
      if (sourceData.length && !oldestData.length && !oldData.length) {
        const filtered = sourceData.filter(item => item.to !== 0)
        oldestData.push(...filtered)
        oldData.push(...filtered)
        this[showDataKey] = filtered
      }
    },
    getDynamicDispatchDataShow() {
      this.dynamicUpData = []
      this.dynamicDownData = []
      this.getDynamicDispatchDataShowIndex += 10
      for (const dynamic of this.dynamicTotalData) {
        const key = dynamic.key
        const targetPinpai = this.brandPercentData[key]
        const hasBike = targetPinpai && (targetPinpai.PutBikeNumOrigin + targetPinpai.BrandBikeNum > 0)
        const hasEBike = targetPinpai && (targetPinpai.PutEBikeNumOrigin + targetPinpai.BrandEBikeNum > 0)
        if (this.action === '上架' || this.action === '上下架') {
          if (this.isBicycle) {
            if (hasBike) {
              this.dynamicUpData.push(
                this.createDataDispatchItem(key, 1, 1, dynamic.bikeUpNumTotal)
              )
            }
          }
          if (this.isElectricBike) {
            if (hasEBike) {
              this.dynamicUpData.push(
                this.createDataDispatchItem(key, 1, 2, dynamic.eBikeUpNumTotal)
              )
            }
          }
        }
        if (this.action === '下架' || this.action === '上下架') {
          if (this.isBicycle) {
            if (hasBike) {
              this.dynamicDownData.push(
                this.createDataDispatchItem(key, 2, 1, dynamic.bikeDownNumTotal)
              )
            }
          }
          if (this.isElectricBike) {
            if (hasEBike) {
              this.dynamicDownData.push(
                this.createDataDispatchItem(key, 2, 2, dynamic.eBikeDownNumTotal)
              )
            }
          }
        }
        if (this.action === '上下架') {
          // 奇偶分类逻辑（保持原样，此处无重复）
          const odds = []
          const evens = []
          for (const index in this.dynamicPinPaiNames) {
            const item = this.dynamicPinPaiNames[index]
            if (index % 2 === 0) {
              evens.push(item)
            } else {
              odds.push(item)
            }
          }
        }
      }
      // 提取总量数据添加逻辑
      this.addTotalDispatchData()
      // 提取数据过滤初始化逻辑
      this.initShowDispatchData()
    },
    createDataDispatchItem(key, type, vehicleType, value) {
      return {
        name: this.getLabelDispatchName(key, type, vehicleType),
        from: 0,
        to: value,
        duration: this.getDuration()
      }
    },
    getLabelDispatchName(key, type, vehicleType) {
      // type: 1-上架，2-下架
      // vehicleType: 1-单车，2-电车
      if (key === '美团电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '美团单车(上架)'
          } else if (type === 2) {
            return '美团单车(下架)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '美团电单(上架)'
          } else if (type === 2) {
            return '美团电单(下架)'
          }
        }
      }
      if (key === '哈啰电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '哈啰单车(上架)'
          } else if (type === 2) {
            return '哈啰单车(下架)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '哈啰电单(上架)'
          } else if (type === 2) {
            return '哈啰电单(下架)'
          }
        }
      }
      if (type === 1) {
        return `${key}(上架)`
      } else if (type === 2) {
        return `${key}(下架)`
      }
    },
    addTotalDispatchData() {
      if (this.action === '上架' || this.action === '上下架') {
        this.dynamicUpData.unshift({
          name: '上架总量',
          from: 0,
          to: this.dynamicAllToatal.up,
          duration: 6000
        })
      }
      if (this.action === '下架' || this.action === '上下架') {
        this.dynamicDownData.unshift({
          name: '下架总量',
          from: 0,
          to: this.dynamicAllToatal.down,
          duration: 6000
        })
      }
    },
    initShowDispatchData() {
      if (this.dynamicUpData.length) {
        this.dynamicUpShowData = this.dynamicUpData.filter(item => item.to !== 0)
      }
      if (this.dynamicDownData.length) {
        this.dynamicDownShowData = this.dynamicDownData.filter(item => item.to !== 0)
      }
    },
    translateDynamicData(data) {
      let rentData = 0
      let returnData = 0
      for (const pinpaiName in data) {
        const pinpai = data[pinpaiName]
        let bikeRentNumTotal = 0
        let bikeReturnNumTotal = 0
        let eBikeRentNumTotal = 0
        let eBikeReturnNumTotal = 0
        for (const p of pinpai) {
          if (this.isBicycle) {
            bikeRentNumTotal += p.bike_rent_num
            bikeReturnNumTotal += p.bike_return_num
          }
          if (this.isElectricBike) {
            eBikeRentNumTotal += p.e_bike_rent_num
            eBikeReturnNumTotal += p.e_bike_return_num
          }
        }
        rentData += bikeRentNumTotal + eBikeRentNumTotal
        returnData += bikeReturnNumTotal + eBikeReturnNumTotal
        const temp = {
          bikeRentNumTotal: bikeRentNumTotal,
          bikeReturnNumTotal: bikeReturnNumTotal,
          eBikeRentNumTotal: eBikeRentNumTotal,
          eBikeReturnNumTotal: eBikeReturnNumTotal,
          key: pinpaiName
        }
        this.dynamicTotalData.push(temp)
      }
      this.dynamicAllToatal.rent = rentData
      this.dynamicAllToatal.return = returnData
    },
    translateDispatchDynamicData(data) {
      let upData = 0
      let downData = 0
      for (const pinpaiName in data) {
        const pinpai = data[pinpaiName]
        let bikeUpNumTotal = 0
        let bikeDownNumTotal = 0
        let eBikeUpNumTotal = 0
        let eBikeDownNumTotal = 0
        if (pinpai.length > 0) {
          for (const p of pinpai) {
            if (this.isBicycle) {
              bikeUpNumTotal += p.bike_up_num
              bikeDownNumTotal += p.bike_down_num
            }
            if (this.isElectricBike) {
              eBikeUpNumTotal += p.e_bike_up_num
              eBikeDownNumTotal += p.e_bike_down_num
            }
          }
        }
        upData += bikeUpNumTotal + eBikeUpNumTotal
        downData += bikeDownNumTotal + eBikeDownNumTotal
        const temp = {
          bikeUpNumTotal: bikeUpNumTotal,
          bikeDownNumTotal: bikeDownNumTotal,
          eBikeUpNumTotal: eBikeUpNumTotal,
          eBikeDownNumTotal: eBikeDownNumTotal,
          key: pinpaiName
        }
        this.dynamicTotalData.push(temp)
      }
      this.dynamicAllToatal.up = upData
      this.dynamicAllToatal.down = downData
    },
    sliceDate(params, data) {
      // 如果在本月本日本年 过滤掉 超过当前期限的数据
      const today = new Date()
      let slicelength = 0
      if (params.year === today.getFullYear() && !params.month) {
        slicelength = today.getMonth() + 1
      }
      if (params.month === today.getMonth() + 1 && !params.day) {
        slicelength = today.getDate()
      }
      if (params.day === today.getDate()) {
        slicelength = today.getHours() + 1
      }
      if (slicelength) {
        for (const key in data) {
          if (data[key].length > 0) {
            data[key] = data[key].slice(0, slicelength)
            if (data[key].slice(-1)[0].num === 0) {
              data[key].splice(-1)
            }
          }
        }
      }
      return data
    },
    getDynamicApi() {
      // 每次潮汐图改动的时候，都会触发统计数据改动
      // 统计数据自己改动
      const vm = this
      Api.tidal2(vm.dynamicApiParams)
        .then((res) => {
          if (res.code === 200) {
            vm.dynamicTotalData = []
            if (vm.dataType === '月') {
              const filledData = this.fillDates(res.data)
              res.data = filledData
            }
            res.data = this.sliceDate(vm.dynamicApiParams, res.data)
            vm.translateDynamicData(res.data)
            vm.getDynamicDataShow()
            clearTimeout(vm.dynamicTimer)
            vm.dynamicTimer = null
            vm.dynamicTimer = setTimeout(vm.getDynamicApi, 1000 * 20) // 20s
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 潮汐统计月租还数据，自动补充未补齐月份当中的日期数据
    fillDates(data) {
      const endDateObj = new Date() // 当前日期即结束日期
      let earliestDate = endDateObj // 假设最早日期是结束日期
      // 找到所有子数组中的最早日期
      Object.keys(data).forEach(key => {
        data[key].forEach(item => {
          const itemDate = new Date(item.date)
          if (itemDate < earliestDate) {
            earliestDate = itemDate
          }
        })
      })
      earliestDate = earliestDate.toISOString().split('T')[0] // 转换回 YYYY-MM-DD 格式
      // 处理每个子数组
      const result = {}
      Object.keys(data).forEach(key => {
        const filledItems = []
        // 生成从最早日期到结束日期的完整列表
        const currentDate = new Date(earliestDate)
        while (currentDate <= endDateObj) {
          const currentDateString = currentDate.toISOString().split('T')[0]
          const existingItem = data[key].find(item => item.date === currentDateString)
          filledItems.push(existingItem || { date: currentDateString, bike_return_num: 0, bike_rent_num: 0, e_bike_return_num: 0, e_bike_rent_num: 0 })
          currentDate.setDate(currentDate.getDate() + 1)
        }
        result[key] = filledItems
      })
      return result
    },
    tidal(isYearChange, data, id, originDataName, chartName) {
      const vm = this
      vm.loading = true
      const format = vm.selectYear
        ? vm.getSiteParams(vm.selectYear)
        : vm.getSiteParams()
      const params = {
        selfAreaId: !this.isAggregation
          ? this.selfAreaId
          : vm.selfAreaIdOrAggregationId,
        year: format[0],
        action: vm.action,
        dataType: vm.dataType
      }
      if (!this.isAggregation) {
        params.mold = 1
      }
      if (this.dataType === '日') {
        params.month = format[1]
        params.day = format[2]
      } else if (this.dataType === '月') {
        params.month = format[1]
      } else if (this.dataType === '年') {
      }
      // 浮层数据获取参数
      if (data && data.month) {
        if (data.label === '日') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = this.monthCache
            ? this.monthCache
            : new Date().getMonth() < 9
              ? '0' + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1
          params.day = Number(data.key) < 10 ? '0' + data.key : data.key
        } else if (data.label === '月') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = Number(data.key) < 10 ? '0' + data.key : data.key
        }
      }
      // 测试专用
      // params.month = '03'
      // 版本2
      Api.tidal2(params)
        .then((res) => {
          if (res.code === 200) {
            res.data = this.sliceDate(params, res.data)
            vm.pinpaiSort = vm.getPinpaiSort(res.data)
            vm.dynamicTotalData = []
            vm.translateData(res.data)
            if (vm.action === '租车' || vm.action === '还车' || vm.action === '租还') {
              vm.onResetTide()
              vm.translateDynamicData(res.data)
              vm.getDynamicDataShow()
            } else {
              vm.onResetTide()
              vm.translateDispatchDynamicData(res.data)
              vm.getDynamicDispatchDataShow()
            }
            if (data && data.month) {
              vm[originDataName] = this.pSort
              if (vm[chartName]) {
                vm[chartName].destroy()
              }
              vm.$nextTick(() => {
                vm.initScale(id, originDataName, chartName, data)
              })
              return
            }
            vm.tidalData = this.pSort
            vm.getpinpai()
            if (vm.chart) {
              vm.chart.destroy()
            }
            vm.$nextTick(() => {
              vm.initScale(null, 'tidalData', 'chart', null)
            })
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getpinpai() {
      const vm = this
      vm.pinpaiNames = []
      for (const key in vm.tidalData) {
        vm.pinpaiNames.push(key.slice(1))
      }
    },
    getScaleData(originDateName, id, pargetPoint) {
      const data = []
      this.realPinpaiNames = []
      this.dynamicPinPaiNames = []
      if (id) {
        if (pargetPoint.label === '月') {
          for (const key in this[originDateName]) {
            data.push(
              ...this.objectToArrayFromMonth(this[originDateName][key], key)
            )
          }
        } else if (pargetPoint.label === '日') {
          for (const key in this[originDateName]) {
            data.push(
              ...this.objectToArrayFromHours(this[originDateName][key], key)
            )
          }
        }
        return data
      }
      if (this.dataType === '日') {
        // 小时
        for (const key in this[originDateName]) {
          data.push(
            ...this.objectToArrayFromHours(this[originDateName][key], key)
          )
        }
      } else if (this.dataType === '月') {
        // 天
        for (const key in this[originDateName]) {
          data.push(
            ...this.objectToArrayFromMonth(this[originDateName][key], key)
          )
        }
      } else if (this.dataType === '年') {
        // 月
        for (const key in this[originDateName]) {
          data.push(
            ...this.objectToArrayFromYear(this[originDateName][key], key)
          )
        }
      }
      return data
    },
    getAction(key) {
      const names = []
      const bpre = key.slice(1, 3)
      const epro = key.slice(1)
      const targetPinpai = this.brandPercentData[key.slice(1)]
      const hasBike =
        targetPinpai &&
        targetPinpai.PutBikeNumOrigin + targetPinpai.BrandBikeNum > 0
      const hasEBike =
        targetPinpai &&
        targetPinpai.PutEBikeNumOrigin + targetPinpai.BrandEBikeNum > 0
      if (this.action === '租还') {
        if (this.isElectricBike) {
          if (hasEBike) {
            if (epro === '美团出行') {
              names.push('美团电单(租车)')
              names.push('美团电单(还车)')
            } else {
              names.push(`${epro}(租车)`)
              names.push(`${epro}(还车)`)
            }
          }
        }
        if (this.isBicycle) {
          if (hasBike) {
            names.push(`${bpre}单车(租车)`)
            names.push(`${bpre}单车(还车)`)
          }
        }
      } else if (this.action === '租车') {
        if (this.isElectricBike) {
          if (hasEBike) {
            if (epro === '美团出行') {
              names.push('美团电单(租车)')
            } else {
              names.push(`${epro}(租车)`)
            }
          }
        }
        if (this.isBicycle) {
          if (hasBike) {
            names.push(`${bpre}单车(租车)`)
          }
        }
      } else if (this.action === '还车') {
        if (this.isElectricBike) {
          if (hasEBike) {
            if (epro === '美团出行') {
              names.push('美团电单(还车)')
            } else {
              names.push(`${epro}(还车)`)
            }
          }
        }
        if (this.isBicycle) {
          if (hasBike) {
            names.push(`${bpre}单车(还车)`)
          }
        }
      } else if (this.action === '上架') {
        if (this.isElectricBike) {
          if (hasEBike) {
            if (epro === '美团出行') {
              names.push('美团电单(上架)')
            } else {
              names.push(`${epro}(上架)`)
            }
          }
        }
        if (this.isBicycle) {
          if (hasBike) {
            names.push(`${bpre}单车(上架)`)
          }
        }
      } else if (this.action === '下架') {
        if (this.isElectricBike) {
          if (hasEBike) {
            if (epro === '美团出行') {
              names.push('美团电单(下架)')
            } else {
              names.push(`${epro}(下架)`)
            }
          }
        }
        if (this.isBicycle) {
          if (hasBike) {
            names.push(`${bpre}单车(下架)`)
          }
        }
      } else if (this.action === '上下架') {
        if (this.isElectricBike) {
          if (hasEBike) {
            if (epro === '美团出行') {
              names.push('美团电单(上架)')
              names.push('美团电单(下架)')
            } else {
              names.push(`${epro}(上架)`)
              names.push(`${epro}(下架)`)
            }
          }
        }
        if (this.isBicycle) {
          if (hasBike) {
            names.push(`${bpre}单车(上架)`)
            names.push(`${bpre}单车(下架)`)
          }
        }
      }
      this.dynamicPinPaiNames.push(...names)
      this.realPinpaiNames.push(names.length)
      this.rentReturnBrandNames = Object.assign(this.dynamicPinPaiNames)
      return names
    },
    objectToArrayFromHours(items, key) {
      const arrs = []
      const names = this.getAction(key)
      for (const item of items) {
        for (const name of names) {
          const o = {}
          o[item.hour] = item.hour
          o.city = name
          o.month = item.hour + '点'
          o.temperature = this.getTemperature(item, name)
          o.key = item.hour
          o.label = '时'
          arrs.push(o)
        }
      }
      return arrs
    },
    objectToArrayFromMonth(items, key) {
      const arrs = []
      const names = this.getAction(key)
      for (const item of items) {
        for (const name of names) {
          const day = Number(item.date.split('-')[2])
          const o = {}
          o[day] = day
          o.city = name
          o.month = Number(day) < 10 ? '0' + day : String(day)
          o.temperature = this.getTemperature(item, name)
          o.key = day
          o.label = '日'
          arrs.push(o)
        }
      }
      return arrs
    },
    getTitle(item, totalTemperature) {
      if (['租车'].includes(this.action)) {
        return `${item.key}${item.label} ${this.action}总量：${totalTemperature.totalZhuCheTemperature}`
      } else if (['还车'].includes(this.action)) {
        return `${item.key}${item.label} ${this.action}总量：${totalTemperature.totalHuanCheTemperature}`
      } else if (['租还'].includes(this.action)) {
        return `${item.key}${item.label} 租车总量：${totalTemperature.totalZhuCheTemperature} 还车总量：${totalTemperature.totalHuanCheTemperature}`
      } else if (['上架'].includes(this.action)) {
        return `${item.key}${item.label} ${this.action}总量：${totalTemperature.totalUpTemperature}`
      } else if (['下架'].includes(this.action)) {
        return `${item.key}${item.label} ${this.action}总量：${totalTemperature.totalDownTemperature}`
      } else if (['上下架'].includes(this.action)) {
        return `${item.key}${item.label} 上架总量：${totalTemperature.totalUpTemperature} 下架总量：${totalTemperature.totalDownTemperature}`
      }
    },
    objectToArrayFromYear(items, key) {
      const arrs = []
      const names = this.getAction(key)
      for (const item of items) {
        for (const name of names) {
          const month = Number(item.date.split('-')[1])
          const o = {}
          o[month] = month
          o.city = name
          o.month = month + '月'
          o.temperature = this.getTemperature(item, name)
          o.key = month
          o.label = '月'
          arrs.push(o)
        }
      }
      return arrs
    },
    getTemperature(item, name) {
      // 定义操作类型到字段的映射关系
      const rentReturnMap = {
        '出行(租车)': 'e_bike_rent_num',
        '出行(还车)': 'e_bike_return_num',
        '单车(租车)': 'bike_rent_num',
        '单车(还车)': 'bike_return_num',
        '电单(租车)': 'e_bike_rent_num',
        '电单(还车)': 'e_bike_return_num',
        '小骑时代(租车)': 'e_bike_rent_num',
        '小骑时代(还车)': 'e_bike_return_num',
        '小遛共享(租车)': 'e_bike_rent_num',
        '小遛共享(还车)': 'e_bike_return_num',
        '悦来美团(租车)': 'e_bike_rent_num',
        '悦来美团(还车)': 'e_bike_return_num',
        '悦来青桔(租车)': 'e_bike_rent_num',
        '悦来青桔(还车)': 'e_bike_return_num'
      }
      const manageMap = {
        '出行(上架)': 'e_bike_up_num',
        '出行(下架)': 'e_bike_down_num',
        '单车(上架)': 'bike_up_num',
        '单车(下架)': 'bike_down_num',
        '电单(上架)': 'e_bike_up_num',
        '电单(下架)': 'e_bike_down_num',
        '小骑时代(上架)': 'e_bike_up_num',
        '小骑时代(下架)': 'e_bike_down_num',
        '小遛共享(上架)': 'e_bike_up_num',
        '小遛共享(下架)': 'e_bike_down_num',
        '悦来美团(上架)': 'e_bike_up_num',
        '悦来美团(下架)': 'e_bike_down_num',
        '悦来青桔(上架)': 'e_bike_up_num',
        '悦来青桔(下架)': 'e_bike_down_num'
      }
      // 检测操作类型
      const isRentReturn = ['租车', '还车', '租还'].includes(this.action)
      // 在映射表中查找匹配的字段
      const field = isRentReturn
        ? Object.keys(rentReturnMap).find(key => name.includes(key))
        : Object.keys(manageMap).find(key => name.includes(key))
      // 返回对应的字段值
      if (field) {
        return item[isRentReturn ? rentReturnMap[field] : manageMap[field]]
      }
      // 无匹配时返回undefined
      return undefined
    },
    originColor(name) {
      return this.brandOriginColor[name]
    },
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    getColorsByFilterNames() {
      const arr = []
      for (let i = 0, len = this.realNames.length; i < len; i++) {
        const item = this.realNames[i]
        // 区分单车和自行车的颜色
        if (item.indexOf('单车') !== -1) {
          arr.push(this.originColor(item) ? this.originColor(item) : this.getRandomColor())
        } else {
          arr.push(this.eBrandOriginColor(item) ? this.eBrandOriginColor(item) : this.getRandomColor())
        }
      }
      return arr.filter((v) => v)
    },
    getColorsByNames(brandNames) {
      const colorMap = {}
      for (let i = 0, len = brandNames.length; i < len; i++) {
        const item = brandNames[i]
        const newItem = item.slice(0, item.length - 4)
        let color
        // 如果是租还 * 2
        if (this.action === '租还') {
          if (item.indexOf('单车') !== -1) {
            color = this.originColor(newItem) ? this.originColor(newItem) : this.getRandomColor()
          } else {
            color = this.eBrandOriginColor(newItem) ? this.eBrandOriginColor(newItem) : this.getRandomColor()
          }
        } else {
          if (item.indexOf('单车') !== -1) {
            color = this.originColor(newItem) ? this.originColor(newItem) : this.getRandomColor()
          } else {
            color = this.eBrandOriginColor(newItem) ? this.eBrandOriginColor(newItem) : this.getRandomColor()
          }
        }
        colorMap[item] = color
      }
      return colorMap
    },
    getColors(namesNumber) {
      const names = namesNumber || this.realPinpaiNames
      const len = names.length
      const arr = []
      for (let i = 0; i < len; i++) {
        const length = names[i]
        for (let index = 0; index < length; index++) {
          arr.push(this.originColors[i])
        }
      }
      return arr
    },
    getTotalTemperature(data) {
      const temp = {}
      for (const item of data) {
        if (item.city.indexOf('租车') > -1) {
          const key = item.key
          if (!temp[key]) {
            temp[key] = {}
            temp[key].totalZhuCheTemperature = item.temperature || 0
            temp[key].totalHuanCheTemperature = 0
          } else {
            temp[key].totalZhuCheTemperature += item.temperature || 0
          }
        } else if (item.city.indexOf('还车') > -1) {
          const key = item.key
          if (!temp[key]) {
            temp[key] = {}
            temp[key].totalHuanCheTemperature = item.temperature || 0
            temp[key].totalZhuCheTemperature = 0
          } else {
            temp[key].totalHuanCheTemperature += item.temperature || 0
          }
        } else if (item.city.indexOf('上架') > -1) {
          const key = item.key
          if (!temp[key]) {
            temp[key] = {}
            temp[key].totalUpTemperature = item.temperature || 0
            temp[key].totalDownTemperature = 0
          } else {
            temp[key].totalUpTemperature += item.temperature || 0
          }
        } else if (item.city.indexOf('下架') > -1) {
          const key = item.key
          if (!temp[key]) {
            temp[key] = {}
            temp[key].totalDownTemperature = item.temperature || 0
            temp[key].totalUpTemperature = 0
          } else {
            temp[key].totalDownTemperature += item.temperature || 0
          }
        }
      }
      for (const item of data) {
        item.title = `${this.getTitle(item, temp[item.key])}`
      }
      this.dynamicTotalByTime = temp
      return data
    },
    initScale(id, originDateName, chartName, targetPoint) {
      // 有id表示自定义
      let data = this.getScaleData(originDateName, id, targetPoint)
      data = this.getTotalTemperature(data)
      // 过滤重复的品牌名
      const uniqueCities = [...new Set(data.map(item => item.city))]
      let h = 75
      if (data.length > 0) {
        if (this.action === '租还' || this.action === '上下架') {
          h += 185
        } else {
          h += 110
        }
      }
      data.sort((a, b) => {
        return a.key - b.key
      })
      this[chartName] = new Line(id || 'c2', {
        data,
        height: id ? 500 : this.realHeight - h,
        xField: 'month',
        yField: 'temperature',
        seriesField: 'city',
        point: {
          shape: () => {
            return 'circle'
          },
          color: (datum) => {
            const colorMap = this.getColorsByNames(uniqueCities)
            // 直接从映射对象获取对应品牌颜色
            return colorMap[datum.city] || this.color16() // 添加默认颜色兜底
          }
        },
        color: (datum) => {
          const colorMap = this.getColorsByNames(uniqueCities)
          // 直接从映射对象获取对应品牌颜色
          return colorMap[datum.city] || this.color16() // 添加默认颜色兜底
        },
        lineStyle: ({ city }) => {
          // 粗的
          if (
            city.indexOf('出行') > -1 ||
            city.indexOf('电单') > -1 ||
            city.indexOf('小骑时代') > -1 ||
            city.indexOf('小遛共享') > -1
          ) {
            if (city.indexOf('租车') > -1) {
              return {
                lineWidth: 3,
                lineDash: [3, 1]
              }
            } else if (city.indexOf('还车') > -1) {
              return {
                lineWidth: 3
              }
            }
          } else {
            if (city.indexOf('租车') > -1) {
              return {
                lineWidth: 1,
                lineDash: [3, 1]
              }
            } else if (city.indexOf('还车') > -1) {
              return {
                lineWidth: 1
              }
            }
          }
          return {
            lineWidth: 1
          }
        },
        legend: {
          position: 'top-left',
          flipPage: false,
          itemName: {
            style: {
              fill: '#999'
            }
          }
        },
        tooltip: {
          title: 'title',
          domStyles: {
            'g2-tooltip': {
              transform: 'translateY(-150px)', // 向上移动
              transition: 'transform 0.3s ease-in-out' // 添加平滑动画效果
            }
          }
        }
      })

      this[chartName].on('element:click', (event) => {
        // 点击数据
        if (
          event &&
          event.data &&
          event.data.data &&
          event.data.data.temperature
        ) {
          this.onClickPoint(event.data.data)
        }
      })

      this[chartName].render()
      this.loading = false
    },
    handleCloseExportLog() {
      this.exportTime = new Date()
      this.pinpai = []
      this.legality = null
      this.exportLogType = null
      this.exportLogAction = '全部'
      this.logData = '5'
      this.$refs['export-log'].onCloseDialog()
    },
    onExportLogShowModel(idx, time) {
      this.exportLogType = idx
      if (time) {
        this.logType = time
      }
      this.$refs['export-log'].onShowDialog()
    },
    async getEnterpriseListAndHasLength() {
      const vm = this
      const params = {}
      params.selfAreaId = vm.selfAreaId
      return new Promise((resolve, reject) => {
        Api.getEnterpriseList(params)
          .then((res) => {
            if (res.code === 200 && res.data && res.data.total) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            resolve(false)
            console.log('the getEnterpriseList has probleam: ', err)
          })
      })
    },
    onExportLogPre() {
      const vm = this
      if (!vm.pinpai.length) {
        vm.$message.warning('请先选择品牌！')
        return
      }
      if (!vm.exportTime && vm.exportLogType !== 3) {
        vm.$message.warning('请先选择导出时间！')
        return
      }
      if (vm.exportLogType === 4 && !vm.exportTime[0] && !vm.exportTime[1]) {
        vm.$message.warning('请先选择导出时间！')
        return
      }
      if (vm.logData.length === 0) {
        vm.$message.warning('请先选择导出数据类型！')
        return
      }
      const params = {}
      params.selfAreaId = vm.selfAreaIdOrAggregationId
      Api.getEnterpriseList(params).then((res) => {
        if (res.code === 200) {
          const selectPinpaiIds = []
          vm.pinpai.forEach((item) => {
            res.data.lists.forEach((it) => {
              if (
                item === it.brandName &&
                vm.pinpai.indexOf(it.brandId) === -1
              ) {
                selectPinpaiIds.push(it.brandId)
              }
            })
          })
          if (vm.exportLogType === 1) {
            vm.onExportLogDiaodu(selectPinpaiIds)
          } else if (vm.exportLogType === 2) {
            vm.onExportLog(selectPinpaiIds)
          } else if (vm.exportLogType === 3) {
            vm.onExportBike(selectPinpaiIds)
          } else if (vm.exportLogType === 4) {
            vm.onExportBikeOnline(selectPinpaiIds)
          }
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    onExportLogDiaodu(selectPinpaiIds) {
      const vm = this
      const formatTime = vm.getSiteParams(vm.exportTime)
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(','),
        year: formatTime[0]
      }
      if (vm.dataType === '月') {
        params.month = formatTime[1]
      }
      if (vm.dataType === '日') {
        params.month = formatTime[1]
        params.day = formatTime[2]
      }
      if (vm.exportLogAction === '上架') {
        params.action = 1
      }
      if (vm.exportLogAction === '下架') {
        params.action = 2
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.reqLogOutDiaodu(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '调度日志导出.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onExportBikeOnline(selectPinpaiIds) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(','),
        dataType: vm.logData,
        timeType: vm.logType
      }
      if (vm.logType === '年') {
        if (vm.logData === '4') {
          // 调度时间查询是时间戳
          params.dispatchStartTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD HH:mm:ss')
          params.dispatchEndTime = this.dayjs(vm.exportTime[1]).add(1, 'month').format('YYYY-MM-DD HH:mm:ss')
        }
        params.startTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM')
        params.endTime = this.dayjs(vm.exportTime[1]).format('YYYY-MM')
      }
      if (vm.logType === '月') {
        if (vm.logData === '4') {
          // 调度时间查询是时间戳
          params.dispatchStartTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD HH:mm:ss')
          params.dispatchEndTime = this.dayjs(vm.exportTime[1]).add(1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
        params.startTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD')
        params.endTime = this.dayjs(vm.exportTime[1]).format('YYYY-MM-DD')
      }
      if (vm.logType === '日') {
        if (vm.logData === '3' || vm.logData === '4') {
          // 调度时间查询是时间戳
          params.dispatchStartTime = this.dayjs(vm.exportTime[0]).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss')
          params.dispatchEndTime = this.dayjs(vm.exportTime[1]).add(1, 'hour').minute(0).second(0).format('YYYY-MM-DD HH:mm:ss')
        }
        params.startTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(vm.exportTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.brandBikeOnlinelog(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '车辆定时统计.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onExportBike(selectPinpaiIds) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(',')
      }
      if (this.legality !== null) {
        params.legality = this.legality
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.sitebikeOut(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '车辆统计.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onExportLog(selectPinpaiIds) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(','),
        time: vm.getToday(vm.exportTime)
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.reqLogOut(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '潮汐统计.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    // 排名下载
    onExportSite() {
      const vm = this
      const format = vm.getSiteParams(vm.siteRankAllTime)
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        year: format[0],
        siteType: vm.siteType,
        orderBy: vm.orderBy
      }
      if (vm.siteType === '时') {
        params.month = format[1]
        params.day = format[2]
        params.hour = format[3]
        params.dateTime = params.year + '-' + params.month + '-' + params.day + '-' + params.hour
      }
      if (vm.siteType === '日') {
        params.month = format[1]
        params.day = format[2]
        params.dateTime = params.year + '-' + params.month + '-' + params.day
      }
      if (vm.siteType === '月') {
        params.month = format[1]
        params.dateTime = params.year + '-' + params.month
      }
      Api.siteRankAllOut(params).then((res) => {
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        const content = res
        const blob = new Blob([content])
        const fileName = '站点排名分析.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onSiteRankAllTime() {
      if (!this.siteRankAllTime) {
        this.siteRankAll(true)
      } else {
        this.siteRankAll()
      }
    },
    getSiteParams(data) {
      const vm = this
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime()
      const format = t.split('-')
      return format
    },
    // 排名
    siteRankAll(type) {
      const vm = this
      vm.tableLoading = true
      const format = vm.getSiteParams(vm.siteRankAllTime)
      const params = {
        selfAreaId: vm.selfAreaId,
        year: format[0],
        siteType: vm.siteType,
        orderBy: vm.orderBy
      }
      params.month = format[1]
      params.day = format[2]
      params.hour = format[3]
      params.dateTime = params.year + '-' + params.month + '-' + params.day
      if (vm.siteType === '时') {
        params.startTime = params.year + '-' + params.month + '-' + params.day + ' ' + params.hour + ':00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' ' + params.hour + ':59:59'
      }
      if (vm.siteType === '日') {
        params.startTime = params.year + '-' + params.month + '-' + params.day + ' 00:00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' 23:59:59'
      }
      if (vm.siteType === '月') {
        params.startTime = params.year + '-' + params.month + '-01' + ' 00:00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' 23:59:59'
      }
      Api.siteRankAll(params)
        .then((res) => {
          if (res.code === 200) {
            vm.tableData = res.data
            vm.total = res.data.length
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
        .catch((err) => {
          console.log(err)
          vm.tableLoading = false
        })
    },
    // 站点排名统计排序
    handleSortChange({ column, prop, order }) {
      if (order === 'ascending') {
        if (prop === 'rentNum') {
          this.orderBy = 'rent_num asc'
        } else if (prop === 'returnNum') {
          this.orderBy = 'rent_num asc'
        } else if (prop === 'upNum') {
          this.orderBy = 'up_num asc'
        } else {
          this.orderBy = 'down_num asc'
        }
      } else {
        if (prop === 'rentNum') {
          this.orderBy = 'rent_num desc'
        } else if (prop === 'returnNum') {
          this.orderBy = 'rent_num desc'
        } else if (prop === 'upNum') {
          this.orderBy = 'up_num desc'
        } else {
          this.orderBy = 'down_num desc'
        }
      }
    },
    getTodayTime(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()) +
        '-' +
        day2.getHours() +
        '-' +
        day2.getMinutes()
      )
    },
    getToday(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate())
      )
    },
    getDaysInOneMonth(year, month) {
      month = parseInt(month, 10)
      const day = new Date(year, month, 0)
      const n = day.getDate()
      const o = {}
      for (let i = 1; i <= n; i++) {
        o[i] = 0
      }
      return o
    },
    getValue(n, total) {
      if (n === 0 || total === 0) {
        return 0
      }
      return Number((Number(Number(n / total).toFixed(3)) * 100).toFixed(1))
    },
    getPinPaiName(originName, type) {
      // originName - 品牌原名，key：1-自行车，2-电动车
      if (type === 1) {
        return originName.slice(1).slice(0, 2) + '单车'
      } else if (type === 2) {
        if (originName.indexOf('美团出行') > -1) {
          return '美团电单(电动车)'
        }
        return originName.slice(1)
      }
      console.log(originName, 'originName')
    },
    getPinPaiNameTwo(originName, type) {
      // originName - 品牌原名，key：1-自行车，2-电动车
      if (type === 1) {
        return originName.slice(1).slice(0, 2) + '单车'
      } else if (type === 2) {
        if (originName.indexOf('美团出行') > -1) {
          return '美团电单'
        }
        return originName.slice(1)
      }
    },
    getPinpaiSort(data) {
      const list = []
      if (!data) {
        return list
      }
      for (const key in data) {
        list.push(key)
      }
      return list
    },
    initCircle1DataNew() {
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: this.selfAreaId
        }
        Api.brandPercentNew(params)
          .then((res) => {
            if (res.code === 200) {
              const cData = []
              const areadata = {
                areaBikeNum: res.data.areaBikeNum,
                areaEleBikeNum: res.data.areaEleBikeNum
              }
              delete res.data.areaBikeNum
              delete res.data.areaEleBikeNum
              this.pinpaiSort = Object.keys(res.data || {})
              const tableData = this.translateData2(res.data)
              this.brandPercentData = res.data
              const onlineTotal = Object.values(tableData).reduce(
                (per, cur) => {
                  if (this.isBicycle) {
                    per += cur.PutBikeNum
                  }
                  if (this.isElectricBike) {
                    per += cur.PutEBikeNum
                  }
                  return per
                },
                0
              ) //  总在线量
              let setCountTotal = 0
              for (const key in tableData) {
                if (!tableData[key]) {
                  continue
                }
                // 保留原始数据
                tableData[key].PutBikeNumOrigin = tableData[key].PutBikeNum
                tableData[key].PutEBikeNumOrigin = tableData[key].PutEBikeNum
                // 数据修正
                tableData[key].PutBikeNum =
                  tableData[key].PutBikeNum <= tableData[key].BrandBikeNum
                    ? tableData[key].PutBikeNum
                    : tableData[key].BrandBikeNum
                tableData[key].PutEBikeNum =
                  tableData[key].PutEBikeNum <= tableData[key].BrandEBikeNum
                    ? tableData[key].PutEBikeNum
                    : tableData[key].BrandEBikeNum
                // 总核定量
                if (this.isBicycle) {
                  setCountTotal += tableData[key].BrandBikeNum
                }
                if (this.isElectricBike) {
                  setCountTotal += tableData[key].BrandEBikeNum
                }
                const curData = tableData[key]
                // 单车数据集
                if (this.isBicycle) {
                  const tempBike = {
                    type: this.getPinPaiName(key, 1), // key + '(单车)',
                    key: 1,
                    bili: this.getValue(
                      // 在线量占比
                      curData.PutBikeNumOrigin,
                      onlineTotal
                    ),
                    percent: this.getValue(
                      curData.PutBikeNumOrigin,
                      curData.BrandBikeNum
                    ),
                    online: curData.PutBikeNumOrigin,
                    inSite: curData.SiteBikeNum,
                    setCount: curData.BrandBikeNum
                  }
                  if (tempBike.online + tempBike.setCount > 0) {
                    cData.push(tempBike)
                    this.realNames.push(this.getPinPaiName(key, 1))
                  }
                }
                // 电车数据集
                if (this.isElectricBike) {
                  const tempEBike = {
                    type: this.getPinPaiName(key, 2), // key + '(电动车)',
                    key: 2,
                    bili: this.getValue(
                      // 在线量占比
                      curData.PutEBikeNumOrigin,
                      onlineTotal
                    ),
                    percent: this.getValue(
                      // 在线量占比
                      curData.PutEBikeNumOrigin,
                      curData.BrandEBikeNum
                    ),
                    online: curData.PutEBikeNumOrigin,
                    inSite: curData.SiteEBikeNum,
                    setCount: curData.BrandEBikeNum
                  }
                  if (tempEBike.online + tempEBike.setCount > 0) {
                    cData.push(tempEBike)
                    this.realNames.push(this.getPinPaiName(key, 2))
                  }
                }
              }
              let total = 0
              // 用户账号属性为自行车
              if (this.userBikeType === 0) {
                total = (areadata.areaBikeNum || 0)
              // 用户账号属性为电动车
              } else if (this.userBikeType === 1) {
                total = (areadata.areaEleBikeNum || 0)
              // 用户账号属性包括自行车及电动车
              } else {
                total = (areadata.areaBikeNum || 0) + (areadata.areaEleBikeNum || 0)
              }
              let percent = 0
              if (total) {
                percent = Number(Number(setCountTotal / total).toFixed(2))
              }
              const c3Data = [
                {
                  item: '核定量',
                  count: setCountTotal,
                  percent
                },
                {
                  item: '未核定量',
                  count: total - setCountTotal,
                  percent: 1 - percent
                }
              ]

              try {
                // 在此运行代码
                this.initCircle1(cData, onlineTotal)
                this.initCircle3(c3Data, total)
              } catch (err) {
                // 在此处理错误
                console.log('c3', err)
              }
            } else {
              this.$message.warning(res.message)
            }
            resolve(true)
          })
          .catch((err) => {
            console.log('the initCircle1Data has problem', err)
            reject(err)
          })
      })
    },
    getRandomColor() {
      return '#' + ((Math.random() * 0xffffff) << 0).toString(16)
    },
    initCircle1(cData, total, realNamesNumber) {
      const vm = this
      // 可以通过调整这个数值控制分割空白处的间距，0-1 之间的数值
      const sliceNumber = 0.002

      // 自定义 other 的图形，增加两条线
      registerShape('interval', 'slice-shape', {
        draw(cfg, container) {
          const points = cfg.points
          let path = []
          path.push(['M', points[0].x, points[0].y])
          path.push(['L', points[1].x, points[1].y - sliceNumber])
          path.push(['L', points[2].x, points[2].y - sliceNumber])
          path.push(['L', points[3].x, points[3].y])
          path.push('Z')
          path = this.parsePath(path)
          return container.addShape('path', {
            attrs: {
              fill: cfg.color,
              path
            }
          })
        }
      })
      if (vm.Circle1) {
        vm.Circle1.destroy()
      }
      vm.Circle1 = new Chart({
        container: 'c1',
        autoFit: true,
        height: 250
      })

      const colorArr = this.getColorsByFilterNames()
      colorArr.push('#F5F5F5')
      colorArr.push('#D9D9D9')
      vm.Circle1.data(cData)
      vm.Circle1.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.6
      })
      vm.Circle1.legend({
        flipPage: false
      })
      vm.Circle1.tooltip({
        showTitle: false,
        showMarkers: false,
        itemTpl: `<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>
            <span style="font-weight:bold;color:#000;">{name}: {percent}%</span>
            <p style="margin-top:10px;margin-left:20px;color:#999;">在线量{online}辆</p>
            <p style="margin-top:10px;margin-left:20px;color:#999;">核定量{setCount}辆</p>
            <p style="margin-top:10px;margin-left:20px;color:#999;">站点车辆{inSite}辆</p>
          </li>`
      })
      // 辅助文本
      vm.Circle1.annotation()
        .text({
          position: ['50%', '50%'],
          content: total,
          style: {
            fontSize: 28,
            fill: '#000',
            textAlign: 'center'
          },
          offsetY: -10
        })
        .text({
          position: ['50%', '50%'],
          content: '总在线量',
          style: {
            fontSize: 14,
            fill: '#8c8c8c',
            textAlign: 'center'
          },
          offsetX: 0,
          offsetY: 20
        })
      vm.Circle1.interval()
        .style({
          stroke: 'white',
          lineWidth: 1
        })
        .adjust('stack')
        .position('bili')
        .color('type', colorArr)
        .tooltip(
          'type*bili*percent*online*inSite*setCount',
          (type, bili, percent, online, inSite, setCount) => {
            return {
              name: type,
              bili,
              percent,
              online,
              inSite,
              setCount
            }
          }
        )
        .shape('slice-shape')

      vm.Circle1.render()
    },
    initCircle3(cData, total) {
      const vm = this
      if (vm.Circle3) {
        vm.Circle3.destroy()
      }
      vm.Circle3 = new Chart({
        container: 'c3',
        autoFit: true,
        height: 220
      })
      vm.Circle3.data(cData)
      vm.Circle3.scale('percent', {
        formatter: (val) => {
          val = Math.round(val * 100) + '%'
          return val
        }
      })
      vm.Circle3.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.6
      })
      vm.Circle3.tooltip({
        showTitle: false,
        showMarkers: false,
        itemTpl: `
          <li class="g2-tooltip-list-item">
            <span style="background-color:{color};" class="g2-tooltip-marker"></span>
            <span style="font-weight:bold;color:#000;">{name}: {value}</span>
            <p style="margin-top:10px;margin-left:20px;color:#999;">{name}: {count}辆</p>
          </li>`
      })
      // 辅助文本
      vm.Circle3.annotation()
        .text({
          position: ['50%', '50%'],
          content: total,
          style: {
            fontSize: 28,
            fill: '#000',
            textAlign: 'center'
          },
          offsetY: -10
        })
        .text({
          position: ['50%', '50%'],
          content: '城市总量',
          style: {
            fontSize: 14,
            fill: '#8c8c8c',
            textAlign: 'center'
          },
          offsetX: 0,
          offsetY: 20
        })
      vm.Circle3.interval()
        .adjust('stack')
        .position('percent')
        .color('item', ['#1890ff', '#EEE'])
        .tooltip('item*count*percent', (item, count, percent) => {
          return {
            name: item,
            value: Math.round(percent * 100) + '%',
            count
          }
        })

      vm.Circle3.interaction('element-active')
      vm.Circle3.render()
    }
  },
  components: {
    WTable,
    WDialog,
    AnimateNumber,
    totalSumChart
  }
}
</script>

<style lang="less">
</style>
<style lang="less" scoped>
.datestyle {
  vertical-align: middle;
  width: 125px !important;
}

.datestyle input {
  padding-right: 0px !important;
}

.datestyle2 .el-time-panel {
  width: 100px !important;
}

.datestyle2 .el-time-panel .el-time-panel__content {
  text-align: center !important;
}

.datestyle2
.el-time-panel
.el-time-panel__content
.el-time-spinner
.el-time-spinner__wrapper:nth-child(2)
.el-scrollbar__wrap
ul
li {
  color: #fff;
}

.datestyle2
.el-time-panel
.el-time-panel__content
.el-time-spinner
.el-time-spinner__wrapper:first-child
.el-scrollbar__wrap
ul {
  text-align: right;
}

.table-height-limit {
  .el-table td,
  .el-table th {
    padding: 3px 0;
  }
}
</style>
<style lang="less" scoped>
.layout {
  background: #f0f2f5;
}

.dynamic-show {
  width: 100%;
  display: flex;
  margin-top: 20px;
  margin-bottom: 30px;
  text-align: center;

  & > div.dynamic-item {
    flex: 1;
    border: 1px solid #ebebeb;
    padding: 20px 0;
    margin-left: -1px;

    .num {
      line-height: 1;
      font-size: 20px;
      margin-bottom: 6px;
      color: rgba(0, 0, 0, 0.85);

      &.blue {
        font-size: 20px;
        font-weight: bold;
        color: #1f8ffb;
      }
    }

    .name {
      line-height: 1;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
  }

  & + .dynamic-show {
    margin-top: -31px;
  }
}

.blue {
  color: #409eff;
}

.pointer {
  cursor: pointer;
}

.inlineBlock {
  display: inline-block;
  vertical-align: bottom;
}

.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.flex2 {
  flex: 2;
}

.justbetween {
  justify-content: space-between;
  align-items: center;
}

.border-r-4 {
  border-radius: 8px;
}

.bg-f {
  background-color: #fff;
}

.p16 {
  padding: 16px;
}

.mr12 {
  margin-right: 12px;
}

.mr16 {
  margin-right: 16px;
}

.mt16 {
  margin-top: 16px;
}

.w100 {
  width: 100%;
}

.c-blue {
  color: #1ca0ff;
}

.mr10 {
  margin-right: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb10 {
  margin-bottom: 10px;
}

.mr20 {
  margin-right: 20px;
}

.w120 {
  width: 120px;
}

.fs14 {
  font-size: 14px;
}

.bold {
  font-weight: bold;
}

.c0 {
  color: #000;
}

.table-height-limit {
  height: 220px;
  overflow-y: scroll;

  .el-table td,
  .el-table th {
    padding: 3px 0;
  }
}

.w70 {
  width: 70px;
}

.mr2 {
  margin-right: 8px;
}
 // 深度选择器修改内部元素样式
.site_ranking_table ::v-deep .el-table__cell.is-center {
  padding: 5px 5px;
}
</style>
